<!--首页-->
<template>
	<div class="gray-back" style="height: 100%">
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
		<div class="box ">
			<div class="active-search" @click="showSearch = true">
				<div class="search-box">
					<img class src='../../../assets/images/icon-index-search.png'/>
					<span class="active-search-name">搜索项目/单位/队伍</span>
				</div>
			</div>
					 <div class="active-item" >
						 <p class="active-item-name">{{row.name}}</p>
						 <div class="active-item-info">
							 <img :src="row.pic_url" alt="" srcset="">
							 <span class="info-top-left">正在进行</span>
							 <div class="info-bottom">
								 <div class="left">
									 <span>{{row.member_count}}人参加</span>
								 </div>
								 <div class="right">
									 <span>{{row.saidate_str}}</span>
									 <span>{{row.province}} {{row.city}} </span>
								 </div>
							 </div>
						 </div>
					 </div>
		</div>
			<div class="top-tabs">
				<van-tabs v-model="active">
					<van-tab title="全部"></van-tab>
					<van-tab title="排行"></van-tab>
				</van-tabs>
			</div>

			<van-list
					v-model="loading"
					:finished="finished"
					finished-text="没有更多了"
					@load="onLoad"
			>
		<div class="vote-list"
			 >
			<div class="li"  @click="goDetail(item)"  v-for="(item, index) in list" :key="index">
				<div class="cover">
					<img :src="item.pic_url" />
					<div class="num">{{item.vote_count}}票</div>
				</div>
				<div class="title">
					{{item.mingcheng}}
				</div>
				<div class="subject">{{item.subject_name}}</div>
				<div class="member"><span v-for="(member,index) in item.yundongyuan" :key="index">{{member.name}} </span>&nbsp;</div>
				<div class="member"><span v-for="(member,index) in item.jiaolian" :key="index">{{member.name}} </span>&nbsp;</div>
				<div class="btn" @click.stop="vote(item)"  >投TA一票</div>
			</div>


		</div>
				</van-list>


		</van-pull-refresh>

		<van-dialog v-model="showSearch" title="搜索" show-cancel-button @confirm="onSearchConfrim" @cancel="onSearchCancel">
			<van-cell-group>
				<van-field  size="large" v-model="params.keywords"  clearable placeholder="搜索项目/单位/队伍" />
			</van-cell-group>
		</van-dialog>

		<LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
	</div>
</template>
<style scoped>
	.more-box{
		width: 6.25rem; 
		background: #fff;
		margin:20px auto;
		border-radius: 10px;
		overflow: hidden;
		padding: 20px;
	}
	.more-active{
		width: 100%;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.more-active .solid{width: 4px;height: 25px;border-radius: 4px;background-image: linear-gradient( #1EB2FF , #2B7AFF);margin-right: 5px;}
	.more-active .more-title{color:#333;font-size:16px; height: 25px;line-height: 25px;}
	.more-active .more-right{color:#333;font-size:14px; height: 25px;line-height: 25px;}
	.more-active img{margin-left: 5px;width: 5.5px;height: 10px;}

	.start-item-title{
		 color:#333;font-size:16px; 
	}
	.in-active-start{
		height: 20px;
		font-size: 16px;font-family:PingFangSC-Regular,PingFang SC;
	}
	.start-time{display: flex;align-items: center;}
	.start-time span{color:#333;font-size:12px;font-family:PingFangSC-Medium,PingFang SC }
	.start-time img{width: 12.5px;height: 12.5px;margin-right: 5px;}
	.active-start .into{
		height:26px;
        width:42%;
        background:#E63737;
        border-radius: 26px;
        border: 1px solid #E63737;
		text-align: center;
		line-height: 26px;
		color: #fff;
	}
	.active-start .join{
		height:26px;
        width:42%;
        background:#fff;
        border-radius: 26px;
        border: 1px solid #E63737;
		text-align: center;
		line-height: 26px;
		color:#E63737;
	}


	.active-start{display: flex;justify-content: space-between;margin-top: 10px;}
	/* .active-start .left,.active-start .right{width: 50%;} */
	.active-start .left{position: relative;width: 3.15rem;height: 2rem;overflow: hidden;border-radius: 10px;}
	.active-start .right{flex:1;overflow: hidden;margin-left: 20px;display: flex;flex-direction: column;justify-content: space-between;}
	.active-start .left img{height:100%;}
	.active-start .left .bottom{display: flex;justify-content: space-around;position:absolute;bottom: 0;width: 100%;background: rgba(113,112,113,0.8);height: 20px;line-height: 20px;
	font-size: 12px;color: #fff;}
	.bottom-time-address{display: flex;justify-content: space-around;}
	.active-item{width: 7rem;margin: 0 auto;margin-top: 10px;}
	.active-item-name{font-size:16px;font-family:PingFangSC-Regular,PingFang SC;;font-weight:400; color:'#333'}
	.active-item-info{width:100%;border-radius: 5px;overflow: hidden;margin-top: 5px;position: relative;}
	.active-item-info img{width: 100%;display: block;}
	.info-top-left{position: absolute;top: 10px;left: 10px;padding:0 5px;color:#fff; font-size:12px; font-family:PingFangSC-Medium,PingFang SC;
		display: block;background-image: linear-gradient(to right, #FF9535 , #F5A625);border-radius: 20px;}
	.info-bottom{width: 100%;height: 25px;display: flex;background: rgba(113,112,113,0.8);position: absolute;bottom: 0;line-height: 25px;}
	.info-bottom .left,	.info-bottom .right{width: 50%;}
	.info-bottom .left span{margin-left: 10px;}
	.info-bottom .right{ }
	.info-bottom span{color:#fff;font-size:12px; font-family:PingFangSC-Medium,PingFang SC  }
	.active-search-name{ font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(186,186,186,1); }
    .search-box img{width: 14px;height: 14px;display: block;margin-right: 3px;}
	.active-search{
		width:100%;
		height:1.2rem;
		background:rgba(255,255,255,1);
		overflow: hidden;
	}
	.search-box{
		width:7rem;
		height:0.6rem;
		background:rgba(239,239,244,1);
		border-radius:5px;
		margin: 10px auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.box {
		background: #fff;
		margin-bottom: 0px;
		padding-bottom: 10px;
		overflow: hidden;
	}

	.vote-list{
		display: flex;
		display: -webkit-flex; /* Safari */
		justify-content: space-between;
		flex-wrap: wrap;
		margin: 0.2rem;
	}
	.vote-list .li{
		border-radius: 0.2rem;
		width: 49%;
		justify-content: center;
		background: #fff;
		align-items: center;
		box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.1);
		margin-bottom: 10px;
	}
	.vote-list .li .cover{
		height: 2rem;
		overflow-y: hidden;
		position: relative;
		border-radius: 0.2rem 0.2rem 0 0;
	}
	.vote-list .li .cover img{
		width:100%;
	}
	.vote-list .li .cover .num{
		position: absolute;
		top:10px;
		right:10px;
		font-weight: bold;
		padding: 0 10px;
		font-size: 14px;
		color: #fff;
		background: linear-gradient(to right, #ff1425, #ff983b);
		border-radius: 10px;
		height: 20px;
		line-height: 20px;
	}
	.vote-list .li .title {
		font-size: 16px;
		color: #000;
		padding: 0 4px;
		font-weight: bold;
		white-space:nowrap;
		overflow-y: scroll;
		line-height: 26px;
	}
	.vote-list .li .subject {
		font-size: 12px;
		color: #666;
		padding: 0 4px;
		line-height: 26px;
		white-space:nowrap;
		overflow-y: scroll;
	}

	.vote-list .li .member {
		font-size: 14px;
		color: #333;
		padding: 0 4px;
		line-height: 26px;
		white-space:nowrap;
		overflow-y: scroll;
	}
	.vote-list .li .btn {
		line-height: 40px;
		height: 40px;
		color: #333;
		font-size: 12px;
		font-weight: bold;
		text-align: center;
		margin-top: 10px;
		/* height: 20px; */
		background: linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
		border-radius: 0 0 0.2rem 0.2rem;
	}

	.top-tabs >>> .van-tabs__nav{
		background: none !important;
	}




</style>

<script>
	import Vue from 'vue';
	import TabBar from '@/components/TabBar.vue';
	import LoginDialog from '@/components/LoginDialog.vue';
	import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,
			Tab,
			Tabs,
			NoticeBar,
	} from 'vant';
	Vue.use(Cell).use(Tab).use(Tabs).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);

	export default {
		name: 'Activity',
		components: {
			TabBar,LoginDialog,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data: function () {
			return {
				loginShow:false,
				active:0,
				 row:{

				 },
				showSearch: false,
				isLoading: false,
				loading: false,
				finished: false,
				params: {
					saiqu: this.$route.query.saiqu,
					pageNo: 1,
					pageSize: 5,
					keywords:'',
					sort:'id',
					status: 0
				},
				homeTop : 0,
				list: [],

			}
		},
		filter: {},
		watch:{
			active(val){
				console.log(val);
				if(val == 0){
					this.params.sort = 'id';
				}else{
					this.params.sort = 'num';
				}
				this.onRefresh();
			}
		},
		mounted() {
			document.title = '投票活动';
			let that = this;

			that.params.saiqu = this.$route.query.saiqu;
			// console.log(this.$route.meta)
			that.fetch();
			if (!this.$route.meta.isBack) {
				// 清空查询条件和数据
				that.list = [];
				that.params.pageNo = 1;
				that.loading = true;
				that.finished = false;
				that.getList()

				if (this.$route.query.status) {
					that.active = that.params.status = this.$route.query.status;
					console.log(that.active)
				}
			}
			document.getElementById('app').scrollTop = this.homeTop || 0
			this.$route.meta.isBack = false;
		},
		destroyed() {
		},
		methods: {

			fetch(){
				let that = this;
				that.$api.post('/api/vote/saiqudetail', {
					id:that.params.saiqu
				}, (res) => {
					that.row = res.data;
//					that.copy_text=res.data.share_data.url;
					that.wxShare(that.row.share_data.title,that.row.share_data.desc,that.row.share_data.url,that.row.share_data.pic_url );
				}, (res) => {
					Toast.fail(res.msg);
				})
			},



			getList() {
				let that = this;
				that.$api.get('/api/isai/voteSubjectList', that.params, (res) => {
					that.loading = false;

					if (res.data.currentpage == 1) {
						that.isLoading = false;
						that.list = res.data.list
					} else {
						let list = that.list.concat(res.data.list);

						that.list = list;
					}

					if (res.data.list.length == 0) {
						that.finished = true;
					}
					that.params.pageNo += 1;
				})
			},


			// 上拉加载
			// （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
			// 可以延迟异步的时间
			onLoad() {
				// console.log(1)
				// 异步更新数据
				console.log('this.params.pageNo')

				if (this.params.pageNo > 1) {
					setTimeout(() => {
						this.getList()
					}, 500);
				}

			},

			// 跳转订单详情
			goDetail(  order) {
				// 判断是否成团
				console.log( order)
				this.$router.push({
					name: 'ISaiApplyDetail',
					query: {
						id: order.id
					}
				})

			},

			vote(item){
				let that = this;
				that.$api.post('/api/vote/voteadd', {
					type:'sai',
					pid1: item.id,
					pid2: item.baoming_id,
					pid3: item.saiqu,
				}, (res) => {
					console.log('投票成功');
					item.vote_count++;
					Toast('投票成功');
				}, (res) => {
					Toast.fail(res.msg);

					console.log('没有登录');
					if (res.code == 401 || res.code==402) {
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
				})
			},

			goDetail(item){
				rbLink({name:'ISaiVoteDetail',query:{id:item.id}});
			},

			onRefresh() {
				let that = this;
				that.params.pageNo = 1;
				that.getList();
			},

			onSearchConfrim(){
				this.onRefresh();
			},
			onSearchCancel(){
				this.params.keywords= '';
				this.onRefresh();
			},

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},


		}
	}
</script>



// WEBPACK FOOTER //
// VoteList.vue?5604dedc